import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=4f6a6dc9&"
import script from "./FlashMessage.vue?vue&type=script&lang=js&"
export * from "./FlashMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6a6dc9')) {
      api.createRecord('4f6a6dc9', component.options)
    } else {
      api.reload('4f6a6dc9', component.options)
    }
    module.hot.accept("./FlashMessage.vue?vue&type=template&id=4f6a6dc9&", function () {
      api.rerender('4f6a6dc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/modal/FlashMessage.vue"
export default component.exports